// extracted by mini-css-extract-plugin
export default {"root":"FileListGallery_root__WxJSN"};